﻿import Tab from "@grindex-client/components/Tabs/Tab.class";
import TabListDom from "./TabList.class.dom.js";
import { events } from "@grindex-common/helpers/events";

export default class TabList {
	constructor($tabModule, startTab) {
		this.dom = new TabListDom($tabModule);
		this.$tabmodule = $tabModule;
		this.tabs = [];
		this.loadedTabs = [];
		this.selectedIndex = 1;
		this.currentTab = null;
		this.startTab = startTab;
		this.defaultTab = null;
		this.defaultTabName = "overview";

		window.addEventListener(events.TAB_ALL_LOADED, this.whenAllTabsAreLoaded.bind(this));
	}

	addTabToListOfLoaded(tab) {
		this.loadedTabs.push(tab);
	}

	deactivateAllExcept(tabName) {
		this.loadedTabs.filter((loadedTab) => loadedTab.tabName !== tabName).forEach((otherTab) => otherTab.deactivate());
	}

	createTabs(tabNames) {
		if (!tabNames) {
			throw new Error("Cannot create a tabList with empty or undefined list of tab names");
		}

		tabNames.forEach((tabName) => {
			var tab = new Tab(tabName, this.dom);

			this.tabs.push(tab);

			if (tabName === this.defaultTabName) {
				tab.order = 1;
				this.defaultTab = tab;
			}
		});
	}

	tryGetTabs() {
		this.tabs.forEach((tab) => {
			tab.tryGetTab();
		});
	}

	whenAllTabsAreLoaded() {
		this.tabs = this.tabs.filter((tab) => {
			return tab.isLoaded();
		});

		this.tabs.forEach((tab) => {
			tab.deactivate();
		});

		this.setTabWithFallback(this.startTab);
	}

	disableAllExceptCurrent() {
		const $inactiveTabs = this.getTabsExceptCurrent();

		$inactiveTabs.forEach((inactiveTab) => {
			inactiveTab.deactivate();
		});
	}

	setCurrentTab(tab) {
		this.currentTab = tab && tab.isLoaded() ? tab : this.getTabByIndex(1);

		this.selectedIndex = this.currentTab.order;
	}

	getTabsExceptCurrent() {
		return this.tabs.filter((tab) => {
			return tab.isLoaded() && tab.order !== this.selectedIndex;
		});
	}

	setTabWithFallback(identifier) {
		let tab = null;

		if (Number.isInteger(identifier * 1)) {
			tab = this.getTabByIndex(identifier * 1);
		} else {
			tab = this.getTabByName(identifier);
		}

		this.deactivateAllExcept(tab.tabName);

		this.setCurrentTab(tab);

		this.currentTab.activate();
	}

	getTabByIndex(tabIndex) {
		return this.tabs.filter((tab) => {
			return tab.order === tabIndex;
		})[0];
	}

	getTabByName(name) {
		return this.tabs.filter((tab) => {
			return tab.tabName === name;
		})[0];
	}

	tabExists(name) {
		return !!this.getTabByName(name);
	}

	currentTabIs(tabName) {
		return this.currentTab.tabName === tabName;
	}
}
